export default import.meta.ROLLDOWN_FILE_URL_lY1tUJ93NGbPkBj1LCstAg